import React, { useEffect } from 'react'
import Maybe from 'components/__new/common/Maybe';
import { ReactComponent as IconCalendar } from "assets/images/icons/project-icons/calendar-blank-gray.svg"
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { weekdays } from 'utils/dateFormat';
import { SelectInput } from 'components/__new/common/form';
import numberOrdinalSuffix from 'utils/numberOrdinalSuffix';
import TimeField from "react-simple-timefield";


const EditRecurringTransferFrequency = ({form, setForm, defaultForm, isDaily, isWeekly, isMonthly}) => {
    
    const frequencyProps = ["Daily", "Weekly", "Monthly"]
    
    const onSubmit = (e) => {
        e.preventDefault();
    }
    
    useEffect(() => {
        setForm(defaultForm)
        // eslint-disable-next-line
    }, [])
    
    
    return (
        <form onSubmit={onSubmit}>
            <div className="w-full pt-4 text-[#121619]">
                
                <SelectInput label="Order Frequency" className='form-input' value={form.frequency} onChange={(e) => setForm({...form, frequency: e.target.value})}>
                    <option value="">Select a Frequency</option>
                    {frequencyProps?.map((item) => (
                        <option key={item} value={item.toLowerCase()}>{item}</option>
                    ))}
                </SelectInput>
                
                <Maybe condition={isMonthly}>
                    <SelectInput label="Day of the month" className='form-input' value={form.dayOfMonth} onChange={(e) => setForm({...form, dayOfMonth: e.target.value})}>
                        <option value="">Select a day of the month</option>
                        {[...Array(32).keys()].slice(1).map((ele, index) =>
                            <option key={index} value={ele}>{numberOrdinalSuffix(ele)}</option>
                        )}
                    </SelectInput>
                </Maybe>
                
                
                <Maybe condition={isWeekly}>
                    <SelectInput label="Day of the week" className='form-input' value={form.dayOfWeek} onChange={(e) => setForm({...form, dayOfWeek: e.target.value})}>
                        <option value="">Select a day</option>
                        {weekdays?.map((item) => (
                            <option key={item} value={item.toLowerCase()}>{item}</option>
                        ))}
                    </SelectInput>
                </Maybe>
                
                <Maybe condition={isDaily || isWeekly}>
                    <div className="form-group">
                        <label>Time of the Day</label>
                        
                        <TimeField
                            className="form-input"
                            value={form.time}
                            onChange={(_, value) => setForm({...form, time: value})}  
                        />
                    </div>
                </Maybe>
            
                <Maybe condition={form.frequency !== ""}>
                    <div className="form-group relative">
                        <label>Start Date</label>
                        <DatePicker
                            value={form?.startDate || ""}
                            className='form-input'
                            minDate={moment().toDate()}
                            placeholderText='Select a date'
                            wrapperClassName='recurring-transfer-date-selector'
                            onChange={(date) => setForm({...form, startDate: moment(date).format('YYYY-MM-DD')})}
                        />
                        
                        <IconCalendar className='absolute right-2 top-7 text-red-500' />
                    </div>
                
                    <div className="form-group relative">
                        <label>End Date</label>
                        <DatePicker
                            value={form?.endDate || ""}
                            className='form-input'
                            minDate={moment(form.startDate || new Date()).add(1, 'day').toDate()}
                            placeholderText='Select a date'
                            wrapperClassName='recurring-transfer-date-selector'
                            onChange={(date) => setForm({...form, endDate: moment(date).format('YYYY-MM-DD')})}
                        />
                        
                        <IconCalendar className='absolute right-2 top-7 text-red-500' />
                    </div>
                </Maybe>
            </div>
        </form>
    )
}


export default EditRecurringTransferFrequency